import React, { useRef, useState } from 'react'
import { Position, State } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { useConfirm } from 'src/features/brands/hooks/baseModelSelecter'
import { ConfirmDialog } from 'src/features/brands/components/confirm/ConfirmDialog'
import { REQUEST_HEADERS, SAVE_SIMULATION_PATH, SEND_MAIL_CONSUMER_PATH } from '../constants'
import { generateSubject } from '../helper'
import { genFrontImgFromCanvas } from 'src/features/generatePdf/helper/generateImages/front'
import { genBackImgFromCanvas } from 'src/features/generatePdf/helper/generateImages/back'
import axios from 'axios'

type Props = {
  state: State
  position: Position
  disabled: boolean
  email: string
  setSavedId: React.Dispatch<React.SetStateAction<string>>
  setIsSave: React.Dispatch<React.SetStateAction<boolean>>
}

export const SaveButton: React.FC<Props> = ({ state, position, disabled, email, setSavedId, setIsSave }) => {
  const { t, locale, isJa, isEn } = useLocale()
  const [isSaving, setIsSaving] = useState(false)
  const executeRef = useRef(false)
  const { isConfirmOpen, setIsConfirmOpen, handleConfirmOpen, handleConfirmClose } = useConfirm()

  const handleSave = async (state: State) => {
    const brand = state.baseModel.brand
    handleConfirmClose()
    setIsSaving(true)
    // ミュータブルすぎる箇所
    genFrontImgFromCanvas(state, brand, position, 'canvasFrontConfirm')
    genBackImgFromCanvas(state, brand, position, 'canvasBackConfirm')
    if (executeRef.current) return
    try {
      executeRef.current = true
      const response = await axios.post(SAVE_SIMULATION_PATH, { state })
      setTimeout(() => {
        if (response.data.id === 999) return
        const subject = generateSubject(response.data.id, brand, isJa, isEn)
        const savedId = response.data.id
        const imageUrlBack = (document.getElementById('canvasBackConfirm') as HTMLCanvasElement).toDataURL()
        const imageUrlFront = (document.getElementById('canvasFrontConfirm') as HTMLCanvasElement).toDataURL()
        setSavedId(savedId)
        axios.post(
          SEND_MAIL_CONSUMER_PATH,
          {
            subject,
            savedId,
            imageUrlBack,
            imageUrlFront,
            email,
            locale
          },
          REQUEST_HEADERS
        )
        setIsSaving(false)
        executeRef.current = false
      }, 2000)
    } catch (err) {
      executeRef.current = false
      console.log(`Error ${err} `)
    }
    setIsConfirmOpen(false)
    setIsSave(true)
  }
  return (
    <ConfirmDialog
      isConfirmOpen={isConfirmOpen}
      openButtonLabel={t.SAVE_BUTTON}
      dialogMessage={t.CONFIRM_SEND_EMAIL}
      color={'primary'}
      variant={'contained'}
      disabled={disabled || isSaving}
      isLoading={isSaving}
      handleOkButton={handleConfirmOpen}
      handleCancelButton={handleConfirmClose}
      handleExecuteButton={() => handleSave(state)}
    />
  )
}
